import { dotsLoading } from "../../ViewUtils.js";
import { error } from "../Message/Message.js";
import * as react from "react";

export function renderLoadState(renderFn, loadState) {
    switch (loadState.tag) {
        case 1: {
            return dotsLoading;
        }
        case 3: {
            return error(loadState.fields[0].split(""));
        }
        case 2: {
            return renderFn(loadState.fields[0]);
        }
        default: {
            return react.createElement(react.Fragment, {});
        }
    }
}

